(function(window, $) {
  'use strict';

  if (!$) {
    return;
  }

  function hideEmptyVariantRows() {
    $('.item-variant>span').each(function() {
      var $this = $(this);

      if ($this.html() === '') {
        $this.parent().addClass('hide');
      }
    });
  }

  function initShippingCalculator() {
    var configNode = document.querySelector('[data-shipping-calculator-config]');
    var calculator = window.Shopify && window.Shopify.Cart && window.Shopify.Cart.ShippingCalculator;
    var config;

    if (!configNode || !calculator) {
      return;
    }

    config = {
      submitButton: configNode.getAttribute('data-submit-button') || 'Calculate shipping',
      submitButtonDisabled: configNode.getAttribute('data-submit-button-disabled') || 'Calculating...',
      moneyFormat: configNode.getAttribute('data-money-format') || ''
    };

    if (configNode.getAttribute('data-customer-is-logged-in') === 'true') {
      config.customerIsLoggedIn = true;
    }

    calculator.show(config);
  }

  $(window).on('load', hideEmptyVariantRows);
  $(initShippingCalculator);
}(window, window.jQuery));
